import React, {useState, useEffect, useRef} from 'react';
import './style.scss';


export default function YoutubeVideo(props) {
    return (
        <div className="youtube-video">
            <iframe
                src={`https://www.youtube.com/embed/${props.id}?rel=0`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
            />
        </div>
    )
}
